module.exports = __webpack_public_path__ + "static/media/purple-fusion.6f07b5a5.png";